import React from "react";

const ContingentSummary = () => {
    return (
        <div>
            Summary
        </div>
    );
}

export default ContingentSummary;